import { cn } from "@/lib/cn";

/**
 * Chữ hai thứ tiếng: tiếng Anh dòng trên, tiếng Hoa dòng dưới (Roary 09/10/2026 — mô tả, loại, màu của sản phẩm).
 *
 * Không có bản tiếng Hoa thì chỉ một dòng như trước, không chừa dòng trống. `note` là dòng phụ nhỏ hơn bên dưới (thương
 * hiệu trong cột Loại / Thương hiệu). `truncate`: trong bảng mỗi dòng cắt gọn, xem đủ bằng tooltip.
 */
export function BilingualText({
  en,
  zh,
  note,
  truncate = false,
  className,
  zhClassName,
}: {
  en: string | null | undefined;
  zh: string | null | undefined;
  note?: string | null;
  truncate?: boolean;
  className?: string;
  zhClassName?: string;
}) {
  const line = truncate ? "truncate" : undefined;
  return (
    <div className={cn("min-w-0", truncate && "overflow-hidden", className)}>
      <div className={line} title={truncate && en ? en : undefined}>{en?.trim() ? en : "—"}</div>
      {zh?.trim() ? (
        <div lang="zh-Hans" className={cn(line, zhClassName)} title={truncate ? zh : undefined}>{zh}</div>
      ) : null}
      {note?.trim() ? <div className={cn(line, "text-2xs text-ink-faint")}>{note}</div> : null}
    </div>
  );
}
